// extracted by mini-css-extract-plugin
module.exports = {"root":"root-19PY7","header":"header-2-kEp","root_loyalty":"root_loyalty-3AW24","button_add":"button_add-3XCFA","button_loading":"button_loading-2O4Ct"};